<template>
  <v-app v-if="isLoading">
    <v-row class="justify-content-center align-items-center">
      <loading />
    </v-row>
  </v-app>
  <div v-else>
    <v-form ref="shopForm" v-model="valid">
      <v-container fluid class="pt-6">
        <v-row>
          <v-col cols="12" lg="9">
            <v-card class="mx-auto EK-card rounded-xl rounded-tl-0 IMThemeGray">
              <v-col>
                <v-row>
                  <v-col cols="12" md="6" class="text-right">
                    <v-col cols="12">
                      <label for="mainImg">صورة المشترك</label>
                      <div class="text-center">
                        <drag-drop-image
                          class="AddMainImg p-2 overflow-hidden"
                          title="أضف صورة"
                          @uploaded="uploadMainImg"
                          :mul="false"
                          style="height: 38px; justify-content: flex-end"
                        ></drag-drop-image>
                        <div class="image-container text-center">
                          <img
                            :src="
                              !shopForm.mainImage[0]
                                ? placeholder
                                : !!shopForm.mainImage[0].path
                                ? domainHost + shopForm.mainImage[0].path.replace('~', '')
                                : shopForm.mainImage[0].base64
                            "
                            alt="category logo"
                            class="rounded-xl w-100 border"
                            style="object-fit: cover; height: 300px; max-width: 300px"
                          />
                        </div>
                      </div>
                    </v-col>
                    <v-row>
                      <v-col cols="12" sm="6" md="12">
                        <label for="storeName">اسم المشترك</label>
                        <v-text-field
                          id="storeName"
                          v-model="shopForm.name"
                          :rules="storeName"
                          class="rounded-tr-0"
                          rounded
                          dense
                          solo
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="storeType">نوع المشترك</label>
                        <v-autocomplete
                          id="storeType"
                          v-model="shopForm.shopType"
                          dense
                          rounded
                          color="IMThemeGray"
                          item-color="IMThemeGray"
                          class="rounded-tr-0"
                          solo
                          :items="shopTypes"
                          item-value="id"
                          item-text="name"
                        >
                          <template v-slot:item="data">
                            <v-list-item-content
                              v-text="data.item.name"
                            ></v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="areaId">المنطقة</label>
                        <v-autocomplete
                          id="areaId"
                          v-model="shopForm.areaId"
                          :rules="areaId"
                          dense
                          rounded
                          color="IMThemeGray"
                          item-color="IMThemeGray"
                          solo
                          class="rounded-tr-0"
                          :items="areasList"
                          item-text="name"
                          item-value="id"
                        >
                          <template v-slot:item="data">
                            <v-list-item-content
                              v-text="data.item.name"
                            ></v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="address">عنوان المشترك</label>
                        <v-text-field
                          id="address"
                          v-model="shopForm.address"
                          class="rounded-tr-0"
                          rounded
                          dense
                          solo
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="categoriesIds">تصنيف المشترك</label>
                        <v-autocomplete
                          id="categoriesIds"
                          v-model="shopForm.categoriesIds"
                          :rules="categoriesIds"
                          chips
                          deletable-chips
                          dense
                          multiple
                          rounded
                          class="rounded-tr-0"
                          color="IMThemeGray"
                          item-color="IMThemeGray"
                          small-chips
                          solo
                          :items="categoriesList"
                          item-value="id"
                          item-text="name"
                        >
                          <template v-slot:item="data">
                            <v-list-item-content
                              v-text="data.item.name"
                            ></v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <v-switch
                          v-model="shopForm.isCustom"
                          label="أوقات دوام مخصصة"
                          class="mt-0"
                          color="IMThemeOrange"
                          dark
                        ></v-switch>
                        <div v-if="!shopForm.isCustom">
                          <label for="schedule">أوقات الدوام</label>
                          <v-autocomplete
                            id="schedule"
                            v-model="shopForm.scheduleTemplateId"
                            dense
                            rounded
                            class="rounded-tr-0"
                            color="IMThemeGray"
                            item-color="IMThemeGray"
                            solo
                            :items="[
                              {
                                id: null,
                                name: 'غير محدد',
                              },
                              ...schedulesList,
                            ]"
                            item-text="name"
                            item-value="id"
                          >
                            <template v-slot:append-outer>
                              <v-btn
                                @click="setAddTimeDialog(true)"
                                class="white"
                                color="IMThemeGray"
                                icon
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </template>
                            <template v-slot:item="data">
                              <v-list-item-content
                                class="border-bottom text-right"
                                v-text="data.item.name"
                              ></v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </div>
                        <div v-if="shopForm.isCustom">
                          <label for="customDaysSelect">تحديد أوقات الدوام المخصصة</label>
                          <v-select
                            id="customDaysSelect"
                            rounded
                            multiple
                            chips
                            deletable-chips
                            color="IMThemeGray"
                            item-color="IMThemeGray"
                            :items="daysList"
                            item-text="name"
                            item-value="id"
                            dense
                            solo
                            v-model="selectedCustomDaysWatcher"
                          ></v-select>
                          <div
                            v-for="(day, index) in shopForm.customSchedules"
                            :key="index"
                          >
                            <div class="text-white">
                              يوم
                              {{ daysList[day.dayofWeek - 1].name }}
                            </div>
                            <v-row>
                              <v-col cols="4">
                                <label for="open">من</label>
                                <v-menu
                                  :ref="'menu_from_' + index"
                                  v-model="selectedCustomDaysMenus[index].from"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="day.open"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      id="open"
                                      v-model="day.open"
                                      v-bind="attrs"
                                      v-on="on"
                                      clearable
                                      readonly
                                      :rules="[
                                        (v) =>
                                          !!v || day.is24H || 'يرجى اختيار وقت بداية',
                                      ]"
                                      solo
                                      dense
                                      rounded
                                      class="rounded-tl-0"
                                      color="IMThemeGray"
                                    ></v-text-field>
                                  </template>
                                  <v-time-picker
                                    v-if="selectedCustomDaysMenus[index].from"
                                    v-model="day.open"
                                    full-width
                                    locale="ar-sy"
                                    color="IMThemeGray"
                                    @click:minute="
                                      $refs['menu_from_' + index][0].save(day.open)
                                    "
                                  ></v-time-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="4">
                                <label for="toTime">إلى</label>
                                <v-menu
                                  :ref="'menu_to_' + index"
                                  v-model="selectedCustomDaysMenus[index].to"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="day.close"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="day.close"
                                      v-bind="attrs"
                                      v-on="on"
                                      readonly
                                      :rules="toTime"
                                      solo
                                      dense
                                      clearable
                                      rounded
                                      class="rounded-tl-0"
                                      color="IMThemeGray"
                                    ></v-text-field>
                                  </template>
                                  <v-time-picker
                                    v-if="selectedCustomDaysMenus[index].to"
                                    v-model="day.close"
                                    full-width
                                    locale="ar-sy"
                                    color="IMThemeGray"
                                    @click:minute="
                                      $refs['menu_to_' + index][0].save(day.close)
                                    "
                                  ></v-time-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="4" class="align-items-end d-flex">
                                <v-checkbox
                                  class="mt-0 pb-3"
                                  v-model="day.is24H"
                                  @change="setOpenClose(day)"
                                  color="IMThemeOrange"
                                  dark
                                  label="24 ساعة"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                        <v-dialog v-model="timeDialog" max-width="500">
                          <v-card class="rounded-xl">
                            <v-card-title
                              class="position-absolute pt-2 px-2"
                              style="z-index: 1"
                            >
                              <v-btn icon color="white" @click="setAddTimeDialog(false)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </v-card-title>
                            <actionSchedule
                              v-if="!shopForm.isCustom"
                              @close="timeDialog = false"
                              id="-1"
                            />
                          </v-card>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" md="6" class="text-right">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="12"
                        class="text-right text-lg-center mt-3"
                      >
                        <v-row>
                          <v-col cols="12" md="7">
                            <label for="registerDate">تاريخ بداية الإشتراك</label>
                            <v-menu
                              v-model="dateMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  id="registerDate"
                                  v-model="shopForm.subscribeStartDate"
                                  readonly
                                  class="rounded-tr-0"
                                  rounded
                                  color="IMThemeGray"
                                  dense
                                  solo
                                  v-bind="attrs"
                                  v-on="on"
                                  append-icon="mdi-calendar"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="shopForm.subscribeStartDate"
                                @input="dateMenu = false"
                                color="IMThemeGray"
                                locale="ar-sy"
                                @change="
                                  ChangeEndDate(
                                    shopForm.subscribeStartDate,
                                    selectedPeriod
                                  )
                                "
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="5">
                            <label for="period">مدة الاشتراك</label>
                            <v-select
                              id="period"
                              v-model="selectedPeriod"
                              class="rounded-tr-0"
                              rounded
                              color="IMThemeGray"
                              item-color="IMThemeGray"
                              :items="periodsItems"
                              item-text="text"
                              item-value="value"
                              dense
                              solo
                              @change="
                                ChangeEndDate(shopForm.subscribeStartDate, selectedPeriod)
                              "
                            ></v-select>
                          </v-col>
                          <v-col cols="12">
                            <label for="endDate">تاريخ الإنتهاء</label>
                            <v-text-field
                              id="endDate"
                              v-model="shopForm.subscribeEndDate"
                              class="rounded-tr-0"
                              readonly
                              rounded
                              color="mainTheme"
                              dense
                              solo
                              disabled
                              append-icon="mdi-calendar"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <div class="overflow-hidden">
                          <label for="position">الاحداثيات</label>
                          <v-btn
                            color="error"
                            class="float-left"
                            @click="
                              shopForm.longitude = null;
                              shopForm.latitude = null;
                            "
                            >تهيئة</v-btn
                          >
                        </div>
                        <v-row>
                          <v-col cols="12" lg="6">
                            <label for="longitude">خط الطول</label>
                            <v-text-field
                              id="longitude"
                              v-model="shopForm.longitude"
                              class="rounded-tr-0"
                              rounded
                              dense
                              solo
                              readonly
                              dir="ltr"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6">
                            <label for="latitude">خط العرض</label>
                            <v-text-field
                              id="latitude"
                              v-model="shopForm.latitude"
                              class="rounded-tr-0"
                              rounded
                              dense
                              solo
                              readonly
                              dir="ltr"
                            ></v-text-field>
                          </v-col>
                          <v-col class="text-center">
                            <v-btn
                              rounded
                              color="info"
                              class="rounded-tr-0"
                              @click="isShow()"
                            >
                              <v-icon>mdi-map</v-icon>
                              تحديد الاحداثيات
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="description">الوصف</label>
                        <v-textarea
                          id="description"
                          v-model="shopForm.description"
                          class="rounded-tr-0"
                          color="secondary"
                          dense
                          rounded
                          rows="6"
                          solo
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <label for="contactInfo">معلومات التواصل</label>
                        <v-container fluid>
                          <v-row>
                            <v-col cols="12" lg="8">
                              <v-text-field
                                v-model="shopForm.mobileNumber"
                                @change="ConvertToArabic(shopForm.mobileNumber)"
                                solo
                                append-icon="mdi-cellphone-basic"
                                dense
                                color="dark"
                                rounded
                                label="موبايل"
                                class="rounded-tr-0"
                                dir="ltr"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="4">
                              <div class="float-left">
                                <v-switch
                                  class="mt-0"
                                  dark
                                  v-model="shopForm.hideMobileNumber"
                                  color="error"
                                  label="إخفاء الرقم"
                                ></v-switch>
                              </div>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="shopForm.phoneNumber"
                                dense
                                color="dark"
                                solo
                                append-icon="mdi-phone"
                                rounded
                                label="هاتف"
                                class="rounded-tr-0"
                                dir="ltr"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="shopForm.email"
                                dense
                                dir="ltr"
                                :rules="email"
                                class="ltr-label rounded-tr-0"
                                solo
                                color="dark"
                                label="Email"
                                rounded
                                append-icon="mdi-email"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <label>معلومات تواصل إضافية</label>
                              <v-autocomplete
                                id="storeType"
                                dense
                                rounded
                                color="IMThemeGray"
                                item-color="IMThemeGray"
                                class="rounded-tr-0"
                                solo
                                v-model="contactInfoType"
                                :items="shopContactInfoType"
                                ref="contactInfoType"
                                item-value="id"
                                item-text="name"
                              >
                                <template v-slot:append-outer>
                                  <v-btn
                                    icon
                                    class="info"
                                    @click="unShiftSocial(contactInfoType)"
                                  >
                                    <v-icon>mdi-plus</v-icon>
                                  </v-btn>
                                </template>
                              </v-autocomplete>
                              <v-row>
                                <v-col
                                  cols="12"
                                  v-for="(cotactInfo, index) in shopForm.shopContactInfos"
                                  :key="index"
                                >
                                  <v-divider></v-divider>
                                  <label>{{
                                    cotactInfo.infoType == 6
                                      ? "اسم الرابط"
                                      : cotactInfo.name
                                  }}</label>
                                  <v-text-field
                                    v-if="cotactInfo.infoType == 6"
                                    v-model="cotactInfo.name"
                                    dense
                                    class="rounded-tr-0"
                                    solo
                                    color="dark"
                                    rounded
                                  ></v-text-field>

                                  <v-text-field
                                    v-model="cotactInfo.link"
                                    :rules="link"
                                    dir="ltr"
                                    dense
                                    class="rounded-tr-0"
                                    solo
                                    color="dark"
                                    :append-icon="
                                      'mdi-' +
                                      (cotactInfo.infoType == 9
                                        ? 'email'
                                        : cotactInfo.infoType == 8
                                        ? 'phone'
                                        : cotactInfo.infoType == 7
                                        ? 'cellphone'
                                        : cotactInfo.infoType == 5
                                        ? 'telegram'
                                        : cotactInfo.infoType == 4
                                        ? 'whatsapp'
                                        : cotactInfo.infoType == 3
                                        ? 'twitter'
                                        : cotactInfo.infoType == 2
                                        ? 'instagram'
                                        : cotactInfo.infoType == 1
                                        ? 'facebook'
                                        : 'wan')
                                    "
                                    :suffix="
                                      cotactInfo.infoType == 9 ||
                                      cotactInfo.infoType == 8 ||
                                      cotactInfo.infoType == 7
                                        ? ''
                                        : cotactInfo.infoType == 5
                                        ? 'https://t.me/'
                                        : cotactInfo.infoType == 4
                                        ? 'https://wa.me/+'
                                        : cotactInfo.infoType == 3
                                        ? 'https://twitter.com/@'
                                        : cotactInfo.infoType == 2
                                        ? 'https://www.instagram.com/'
                                        : cotactInfo.infoType == 1
                                        ? 'https://www.facebook.com/'
                                        : ''
                                    "
                                    rounded
                                  >
                                    <template v-slot:append-outer>
                                      <v-btn
                                        color="error"
                                        icon
                                        @click="removeInfoSocial(index)"
                                      >
                                        <v-icon>mdi-delete-empty </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="8" sm="8">
                              <div class="align-items-baseline float-right">
                                <label class="ml-2" for="otp">رمز المشترك</label>
                                <v-text-field
                                  id="otp"
                                  v-model.number="shopForm.otp"
                                  :rules="otp"
                                  dense
                                  color="dark"
                                  solo
                                  rounded
                                  label="OTP"
                                  class="col-8 rounded-tr-0"
                                  dir="ltr"
                                  type="number"
                                  readonly
                                >
                                  <template v-slot:append>
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-icon @click="GenerateOTP()" v-on="on">
                                          mdi-flash
                                        </v-icon>
                                      </template>
                                      توليد رمز جديد
                                    </v-tooltip>
                                  </template>
                                </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="4" sm="4">
                              <div class="float-left pt-4">
                                <v-switch
                                  dark
                                  v-model="shopForm.isHidden"
                                  color="error"
                                  label="إخفاء"
                                ></v-switch>
                              </div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="12"
                        class="justify-content-around d-flex"
                      >
                        <v-btn
                          rounded
                          class="rounded-tr-0"
                          @click="SubmitSetShop(shopForm)"
                          :disabled="!valid"
                        >
                          تم
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-card>
          </v-col>
          <v-col cols="12" lg="3" class="text-center mx-auto">
            <div style="max-width: 400px" class="mx-auto">
              <div class="IMThemeOrange text-white p-3 rounded-xl rounded-tl-0 mx-4">
                <h6 class="m-0">الصور الملحقة للمشترك</h6>
              </div>
              <div>
                <div v-for="(img, index) in shopForm.subImages" :key="index">
                  <button @click="cancelImg(index)" class="close AClass mt-5">
                    <span style="color: red">&times;</span>
                  </button>
                  <img
                    :src="
                      !img
                        ? placeholder
                        : !!img.path
                        ? domainHost + img.path.replace('~', '')
                        : img.base64
                    "
                    :alt="'store image' + index"
                    class="w-100 rounded-xl mt-4"
                    style="object-fit: cover; height: 200px"
                  />
                </div>
                <div v-if="shopForm.imgSubsState == null">
                  <p class="p-2 text-warning">
                    الرجاء القيام بإضافة اشتراك صور بعد إضافة المشترك للتمكن من إضافة صور
                    ملحقة
                  </p>
                </div>
                <drag-drop-image
                  v-else
                  @uploaded="uploadSubImgs"
                  :mul="true"
                  title="أضف صور"
                  class="overflow-hidden p-2"
                  style="height: 38px; justify-content: flex-end"
                ></drag-drop-image>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-dialog v-model="showMap" width="1000px" scrollable>
          <map-modal @getLatLng="fillLatLng" @close="isShow()" />
        </v-dialog>
      </v-container>
    </v-form>
  </div>
</template>
<style lang="scss">
.v-text-field__suffix {
  direction: ltr;
  font-size: 12px;
  padding-left: 0 !important;
  padding-right: 4px !important;
}
.v-dialog {
  border-radius: 24px !important;
}
.v-input__append-outer {
  margin-top: 1px !important;
  margin-bottom: 0 !important;
  margin-right: 4px !important;
}
.AClass {
  right: 30px;
  position: absolute;
  z-index: 1;
}
.v-input .v-label {
  right: 0 !important;
  left: auto !important;
}
.ltr-label .v-label {
  right: auto !important;
  left: 10px !important;
}
.v-label {
  margin: 0 !important;
}
.v-application--is-rtl .v-input--selection-controls__input {
  margin-right: 8px;
}
.v-input--selection-controls .v-input__slot,
.v-input--selection-controls .v-radio {
  flex-direction: row-reverse;
}
.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  padding: 4px 5px 2px 0 !important;
}
#mainImg {
  border-radius: 2rem;
}
.AddMainImg {
  margin-top: 0 !important;
}
</style>
<script>
import actionSchedule from "@/views/pages/setting/components/action-schedule";
import dragDropImage from "@/components/drag-drop-images.vue";
import {
  singleImageCompressor,
  multiImageCompressor,
  deleteImage,
} from "@/plugins/fileCompresser.service.js";
import { mapActions, mapGetters } from "vuex";
import loading from "@/components/loading";
import MapModal from "./map-modal";
export default {
  components: {
    dragDropImage,
    loading,
    MapModal,
    actionSchedule,
  },
  data: () => ({
    selectedCustomDaysWatcher: [],
    selectedCustomDaysMenus: [
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
      {
        from: false,
        to: false,
      },
    ],
    contactInfoType: 7,
    showMap: false,
    valid: false,
    timeDialog: false,
    selectedPeriod: 1,
    regesterDate: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    dateMenu: false,
    periodsItems: [
      { text: "شهر", value: 1 },
      { text: "شهرين", value: 2 },
      { text: "3 أشهر", value: 3 },
      { text: "4 أشهر", value: 4 },
      { text: "5 أشهر", value: 5 },
      { text: "6 أشهر", value: 6 },
      { text: "7 أشهر", value: 7 },
      { text: "8 أشهر", value: 8 },
      { text: "9 أشهر", value: 9 },
      { text: "10 أشهر", value: 10 },
      { text: "11 شهر", value: 11 },
      { text: "12 شهر", value: 12 },
      { text: "24 شهر", value: 24 },
      { text: "36 شهر", value: 36 },
    ],
    storeName: [(v) => !!v || "يرجى كتابة اسم المشترك"],
    areaId: [(v) => !!v || "يرجى اختيار منطقة"],
    fromTime: [(v) => !!v || "يرجى اختيار وقت بداية"],
    toTime: [(v) => !!v || "يرجى اختيار وقت نهاية"],
    categoriesIds: [(v) => !!v.length || "يرجى اختيار تصنيف واحد على الأقل"],
    otp: [(v) => (!!v && v.length === 6) || "يرجى توليد رمز تحقق من الأيقونة"],
    link: [(v) => !!v || "يرجى ملأ الحقل"],
    /* eslint-disable */

    email: [
      (v) =>
        !!!v ||
        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
          v
        ) ||
        "يرجى كتابة إيميل صحيح",
    ],
  }),
  created() {
    this.fetchShopCreate();
    this.fetchSchedulesList();
    this.fetchAreasList();
    this.fetchSchedules();

    this.setBreadcrumbs([
      {
        text: "المشتركون",
        href: "/shop",
      },
      {
        text: "إضافة مشترك",
        disabled: false,
      },
    ]);
  },
  computed: {
    ...mapGetters([
      "shopForm",
      "categoriesList",
      "areasList",
      "schedulesList",
      "shopTypes",
      "isLoading",
      "placeholder",
      "domainHost",
      "shopContactInfoType",
      "daysList",
    ]),
  },
  methods: {
    ...mapActions([
      "fetchShopCreate",
      "setBreadcrumbs",
      "setShop",
      "fetchSchedulesList",
      "fetchAreasList",
      "fetchSchedules",
      "unShiftSocial",
      "removeInfoSocial",
    ]),
    setOpenClose(day) {
      if (day.is24H) {
        day.open = "00:00";
        day.close = "00:00";
      }
    },
    isShow() {
      this.showMap = !this.showMap;
    },
    fillLatLng(lat, lng) {
      this.shopForm.latitude = lat;
      this.shopForm.longitude = lng;
    },
    ChangeEndDate(startDate, selectedPeriod) {
      if (selectedPeriod !== null) {
        const date = new Date(startDate);
        date.setMonth(date.getMonth() + selectedPeriod);
        this.shopForm.subscribeEndDate = new Date(date).toISOString().substr(0, 10);
      }
    },
    SubmitSetShop(shopForm) {
      this.setShop(shopForm);
    },
    GenerateOTP() {
      this.shopForm.otp = Math.floor(100000 + Math.random() * 900000).toString();
    },
    uploadMainImg(file) {
      singleImageCompressor(file, this.shopForm.mainImage);
    },
    uploadSubImgs(files) {
      multiImageCompressor(files, this.shopForm.subImages);
    },
    cancelImg(index) {
      deleteImage(index, this.shopForm.subImages);
    },
    setAddTimeDialog(val) {
      this.timeDialog = val;
    },
    ConvertToArabic(number) {
      var regex1 = /^[+]*[(]{0,1}[\u0000-\u007F\u0660-\u0669]{1,3}[)]{0,1}[-\s\./\u0000-\u007F\u0660-\u0669]*$/g;

      if (regex1.test(number))
        this.shopForm.mobileNumber = number.replace(/[٠-٩]/g, (d) =>
          "٠١٢٣٤٥٦٧٨٩".indexOf(d)
        );
    },
  },
  watch: {
    selectedCustomDaysWatcher(newVal, lastVal) {
      if (newVal.length > lastVal.length) {
        this.shopForm.customSchedules.push({
          dayofWeek: newVal[newVal.length - 1],
          open: "00:00",
          close: "00:00",
          shopId: 0,
          is24H: false,
        });
      } else {
        lastVal.forEach((item, index) => {
          if (newVal.indexOf(item) == -1) {
            this.shopForm.customSchedules.splice(index, 1);
          }
        });
      }
    },
  },
};
</script>
